<script setup lang="ts">
  import { IconArrowLeft, Text, IconGunKey, IconWireless } from "@ui-kit";
  import { StatusBar, TopBar } from "@src/components";
  import { type ViewType } from "../model";
  import { default as ItemsInZone } from "./ItemsInZone.vue";
  import { default as ItemsWithoutZone } from "./ItemsWithoutZone.vue";

  const {
    zone_path,
    total_item_count = 0,
    found_item_count = 0,
    not_binding_item_count = 0,
    is_scanning,
  } = defineProps<{
    zone_path: string | null;
    total_item_count: number;
    found_item_count: number;
    not_binding_item_count: number;
    is_scanning: boolean;
  }>();

  const emit = defineEmits<{
    (e: "close"): void;
    (e: "click:item", view: ViewType): void;
  }>();
</script>

<template>
  <div class="check-binding" data-testid="check-binding">
    <StatusBar />
    <TopBar :title="$t('Проверка привязки товаров')" :subtitle="zone_path || undefined" @click:left="emit('close')">
      <template #left>
        <IconArrowLeft />
      </template>
    </TopBar>
    <div class="check-binding__content">
      <div class="check-binding__item-list">
        <ItemsInZone :count="found_item_count" :total="total_item_count" @click="emit('click:item', 'found_items')" />
        <ItemsWithoutZone :count="not_binding_item_count" @click="emit('click:item', 'not_binding_items')" />
      </div>
      <div class="check-binding__info-scan">
        <template v-if="is_scanning">
          <IconWireless />
          <Text font="body-regular-12" color="warning">
            {{ $t("Идет сканирование") }}
          </Text>
        </template>
        <template v-else>
          <IconGunKey />
          <Text font="body-regular-12" color="secondary">
            {{ $t("Нажмите на курок для сканирования") }}
          </Text>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .check-binding {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .check-binding__content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    padding: 8px 16px 16px;
  }

  .check-binding__item-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .check-binding__info-scan {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 20px 16px 16px;
    align-items: center;
  }
</style>
